var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    { attrs: { xmlns: "http://www.w3.org/2000/svg", version: "1.1" } },
    [
      _c("rect", {
        attrs: { width: "24", height: "24", fill: "rgba(227, 227, 227, 0.01)" }
      }),
      _vm._v(" "),
      _c("g", [
        _c("path", {
          staticClass: "cls-1",
          attrs: {
            d:
              "M18.9775238,12.4081202h-.9774876l-2.1862793-1.9130878c-.1460485-.1275148-.3532591-.1579103-.5289631-.0778427-.1764441.0800676-.2895021.2557707-.2895021.4492664v1.5416651h-.4841099l-2.1862803-1.9130878c-.1464195-.1275148-.3528891-.1579103-.5289631-.0778427-.1764441.0800676-.2895021.2557707-.2895021.4492664v1.5416641h-.7576733v-2.9954777c0-.1586514-.0759897-.3076658-.2049866-.4003363-.1278849-.0919294-.2943211-.118247-.4444475-.0678349l-.7611942.2537317-.3397293-4.2441187c-.0203876-.2565117-.2346411-.4540849-.4918947-.4540849h-2.025775c-.2572532,0-.4715071.1975732-.4918942.4540849l-.4406476,5.5075407-.681776.2272739c-.2016506.0670938-.3373203.2557707-.3373203.4681711v7.8495531c0,.2724514.2209263.4933777.4933772.4933777h13.955049c.2724514,0,.4933777-.2209263.4933777-.4933777v-6.1051254c0-.2724504-.2209263-.4933777-.4933777-.4933786ZM6.7921095,7.2893786h1.4031229l.060606.7576728h-1.5243349s.0606065-.7576733.060606-.7576728ZM8.0509443,5.4867544l.0653324.8158703h-1.2452121l.0652399-.8158703h1.1146398ZM6.6525478,9.0338058h1.6823387l.0388288.4858713-1.8082771.6028204s.08711-1.0886917.0871096-1.0886917ZM5.5158529,11.5125542l4.2461576-1.4152622v8.4159527h-.7573023v-2.7044926c0-.2724504-.2209263-.4933777-.4933767-.4933777h-1.7444277c-.2724509,0-.4933772.2209263-.4933772.4933777v2.7044926h-.7576733s0-7.0006924-.0000005-7.0006905ZM7.2602801,18.5132465v-2.2111149h.7576728v2.2111149s-.7576733,0-.7576728,0ZM18.484148,18.5132465h-7.735383v-5.118371h1.25105c.2724504,0,.4933777-.2209263.4933777-.4933767v-.9478331l1.5075617,1.3192558c.0900755.0785847.2057285.121954.3250875.121954h1.1628284c.2724504,0,.4933777-.2209263.4933777-.4933767v-.9478331l1.5075626,1.3192558c.0900764.0785847.2057285.121954.3250885.121954h.6694508s0,5.118371-.0000019,5.118371Z"
          }
        }),
        _vm._v(" "),
        _c("path", {
          staticClass: "cls-1",
          attrs: {
            d:
              "M6.7669029,14.557703h1.7444277c.2724504,0,.4933767-.2209263.4933767-.4933777s-.2209263-.4933777-.4933777-.4933777h-1.7444277c-.2724509,0-.4933772.2209263-.4933772.4933777s.2209263.4933777.4933782.4933777Z"
          }
        }),
        _vm._v(" "),
        _c("path", {
          staticClass: "cls-1",
          attrs: {
            d:
              "M6.7669029,12.8132753h1.7444277c.2724504,0,.4933767-.2209263.4933767-.4933767s-.2209263-.4933777-.4933777-.4933777h-1.7444277c-.2724509,0-.4933772.2209263-.4933772.4933777s.2209263.4933777.4933782.4933767Z"
          }
        }),
        _vm._v(" "),
        _c("path", {
          staticClass: "cls-1",
          attrs: {
            d:
              "M13.8532228,14.443162h-1.0942516c-.2724504,0-.4933767.2209263-.4933767.4933767s.2209263.4933777.4933777.4933777h1.0942516c.2724504,0,.4933777-.2209263.4933777-.4933777s-.2209263-.4933777-.4933786-.4933767Z"
          }
        }),
        _vm._v(" "),
        _c("path", {
          staticClass: "cls-1",
          attrs: {
            d:
              "M16.8898449,14.443162h-1.0942516c-.2724504,0-.4933777.2209263-.4933777.4933767s.2209263.4933777.4933777.4933777h1.0942516c.2724514,0,.4933777-.2209263.4933777-.4933777s-.2209263-.4933777-.4933777-.4933767Z"
          }
        }),
        _vm._v(" "),
        _c("path", {
          staticClass: "cls-1",
          attrs: {
            d:
              "M13.8532228,16.3410511h-1.0942516c-.2724504,0-.4933767.2209263-.4933767.4933777s.2209263.4933777.4933777.4933777h1.0942516c.2724504,0,.4933777-.2209263.4933777-.4933777s-.2209263-.4933777-.4933786-.4933777Z"
          }
        }),
        _vm._v(" "),
        _c("path", {
          staticClass: "cls-1",
          attrs: {
            d:
              "M16.8898449,16.3410511h-1.0942516c-.2724504,0-.4933777.2209263-.4933777.4933777s.2209263.4933777.4933777.4933777h1.0942516c.2724514,0,.4933777-.2209263.4933777-.4933777s-.2209263-.4933777-.4933777-.4933777Z"
          }
        })
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }